<template>
    <v-pagination
        color="#5087e6"
        @input="chagePerPage"
        v-model="page_idx"
        :length="setting.total_page"
        :total-visible="setting.total_visible"
    ></v-pagination>
</template>

<script>

  export default {
    name: 'Pagination',
    props: {
        setting: Object,
    },
    components: { },
    data: function(){
      return {
        page_idx: parseInt(this.setting.selected_page) 

      }
    }, 
    created: async function(){
    },
    mounted: function(){
    },
    computed: {
    },
    methods: {
        chagePerPage: async function(page_idx){
            // 加router變數
            let query = this.$route.query;
            let tmp_query = {...query, page: page_idx};
            try {
              await this.$router.push({ path: this.$route.path, query: tmp_query})
            } catch (err) {
              console.log(err)
              if (err.name !== 'NavigationDuplicated') {
                throw err;
              }
            }
            
            // location.reload()
        }
    },
    watch: {
    }     
  }
</script>
<style scoped>
</style>